var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "ui form signupForm",
      class: { warning: _vm.form.hasErrors() },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.post()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "ui two column middle very relaxed stackable grid" },
        [
          _c(
            "div",
            { staticClass: "center aligned column loginForm__column" },
            [
              _c("h2", { staticClass: "signupForm__sectionTitle" }, [
                _vm._v("メールアドレスで登録"),
              ]),
              _vm._v(" "),
              _c("app-message", { attrs: { msg: _vm.form.appMessage } }),
              _vm._v(" "),
              _c("div", { staticClass: "ui form" }, [
                _c(
                  "div",
                  { staticClass: "field" },
                  [
                    _c("div", { staticClass: "ui left icon input" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.model.login_id,
                            expression: "form.model.login_id",
                          },
                        ],
                        attrs: { type: "text", placeholder: "メールアドレス" },
                        domProps: { value: _vm.form.model.login_id },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form.model,
                              "login_id",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("i", { staticClass: "user icon" }),
                    ]),
                    _vm._v(" "),
                    _c("validation-message", {
                      attrs: { form: _vm.form, field: "login_id" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "field" },
                  [
                    _c("div", { staticClass: "ui left icon input" }, [
                      _c("i", { staticClass: "lock icon" }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.model.password,
                            expression: "form.model.password",
                          },
                        ],
                        attrs: { type: "password", placeholder: "パスワード" },
                        domProps: { value: _vm.form.model.password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form.model,
                              "password",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("validation-message", {
                      attrs: { form: _vm.form, field: "password" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "field" },
                  [
                    _c(
                      "checkbox",
                      {
                        model: {
                          value: _vm.form.model.iAgree,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.model, "iAgree", $$v)
                          },
                          expression: "form.model.iAgree",
                        },
                      },
                      [
                        _c(
                          "a",
                          { attrs: { href: "/term", target: "_blank" } },
                          [_vm._v("利用規約")]
                        ),
                        _vm._v("に同意\n          "),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c(
                    "button",
                    {
                      staticClass: "ui fluid orange submit button",
                      class: {
                        "loading disabled": _vm.form.waiting,
                        disabled: !_vm.form.model.iAgree,
                      },
                      attrs: { type: "submit" },
                    },
                    [_vm._v("会員登録")]
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "center aligned column signupForm__column" },
            [
              _c("h2", { staticClass: "loginForm__sectionTitle" }, [
                _vm._v("SNSアカウントで登録"),
              ]),
              _vm._v(" "),
              _vm.socialAuthErrorCode
                ? _c("div", { staticClass: "ui negative message" }, [
                    _vm.socialAuthErrorCode === "oauth"
                      ? _c("span", [
                          _vm._v(
                            "\n        SNSとの連携に失敗しました。\n        "
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "ui form" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "button",
                    {
                      staticClass: "ui fluid large facebook button",
                      class: { "loading disabled": _vm.facebookLoading },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.facebook()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "facebook f icon" }),
                      _vm._v("Facebookで登録する\n          "),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { position: "relative", margin: "0", padding: "0" } },
      [
        _c(
          "div",
          { staticClass: "ui vertical divider signupForm__sectionDivider" },
          [_vm._v("\n        または\n      ")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }